import React from 'react';
import $ from "jquery";
import WaitCube from '../../../WaitCube.js'
import I18nString from '../../../I18nString.js'
import GpyFileUpload from '../lib/GpyFileUpload.js'
import {_GPY,__GPYPost , __GPYGet,__GPYPostDownload} from '../../../env.js'
import { SwatchesPicker } from 'react-color';


class TeamSettings extends React.Component {

	constructor(props) {
			super(props);
			this.state = {
						currentTeam : { id: -1, name: "",colorA: "#F00", colorB:"#0F0" },
						currentPlayer : {id : -1, lastName: "", firstName:"", numOrPos:"", playerId:"",info:"",role:"player"},
						teamsIsLoaded: false,
						teams: {},
						teamUnsave:false,
						playersIsLoaded: false,
	 				 	players: {},
	 				 	playerUnsave: false,
						displayColorpickerA: false,
						displayColorpickerB: false,
			};
	}

	validateTeamName(obj,name){
			var s = obj[name];
			return _GPY.isMin2(s);
	}

	validatePlayerLastName(obj,name){
			var s = obj.lastName;
			return _GPY.isMin2(s);
	}

	validateAny(obj,name){
			return true;
	}

  onChange(obj,key,unsave,validator,e){
			e.preventDefault();
			obj[key] = e.target.value;
			var state = this.state;
			state[unsave] = true;
			if ( validator !== undefined ) {
					state[unsave] = validator(obj,key);
			}
			state.currentTeam = this.state.currentTeam;
			this.setState(state);
	}

	onTeamFileUpload(file){
		var obj = this.state.currentTeam;
		obj.logo = file;
		console.log(obj);
		this.setState({ currentTeam:obj,
			teamUnsave: this.validateTeamName(obj,"name"),
		});
	}

	onPlayerFileUpload(file){
		var obj = this.state.currentPlayer;
		obj.profileImage = file;
		console.log(obj);
		this.setState({currentPlayer:obj,
			playerUnsave: this.validatePlayerLastName(obj,"lastName"),
		});
	}

	componentDidMount(){
		this.getTeams();
	}

 onSelectTeam(team) {
	 	console.log(team);
		var colors = team.color;
		if(colors===undefined) {
			colors = "#F00:#0F0";
		}

		var c = colors.split(":");
		team.colorA = c[0];
		team.colorB = c[1];

		this.setState( {
				currentTeam: team,
				teamUnsave: false,
				playersIsLoaded:false,
				currentPlayer : {id : -1, lastName: "", firstName:"", numOrPos:"", playerId:"",role:"player"},
			});
			this.getPlayers(team.id);
 }

 onSelectPlayer(player){
	 if(player.role === undefined || player.role === '') {
		 player.role = "player";
	 }
	 console.log(player);
	 this.setState( {
	 		currentPlayer: player,
	 		playerUnsave: false,
	 	});
 }

	getTeams() {
		__GPYGet('getTeams',(result)=>{
			this.setState({
				teamsIsLoaded: true,
				teams: result
			})
			this.getPlayers();
		},(err)=>{
			this.setState({
				teamsIsLoaded: false,
			});
		});
	}

	getPlayers(pk) {
		__GPYPost('getPlayers',{teamPk:pk},(res) => {
			this.setState({
				playersIsLoaded: true,
				players: res,
			})
		},(err) => {
			this.setState({
				playersIsLoaded: false,
			})
		});
  }

  deleteTeam() {
		var ct = this.state.currentTeam
		ct.del = true;
		this.setState({currentTeam:ct},()=> {
			this.createOrUpdateTeam();
		});
	}

	deletePlayer() {
		var obj = this.state.currentPlayer;
		obj.del = true;

		obj.teamPk = this.state.currentTeam.id;
		__GPYPost('removePlayerFromTeam',obj,(res)=>{
			this.setState({
				playerIsLoaded: true,
				players: res,
				playerUnsave: false,
			});
			this.onNewPlayer();
		});
	}

  createOrUpdateTeam() {
		var t = this.state.currentTeam;
		t.color = t.colorA+":"+t.colorB;
		__GPYPost('createOrUpdateTeam',t,(res) => {
			console.log(res);
			this.setState({
				teamsIsLoaded: true,
				teams: res,
				teamUnsave: false,
			});
			this.onNewTeam();
		});
	}

	createOrUpdatePlayer(){
		var obj = this.state.currentPlayer;
		obj.teamPk = this.state.currentTeam.id;
		__GPYPost('createOrUpdatePlayer',obj,(res)=>{
			console.log(res) ;
			this.setState({
				playerIsLoaded: true,
				players: res,
				playerUnsave: false,
			});
			this.onNewPlayer();
		});
	}

	onNewTeam() {
		this.setState({currentTeam : { id: -1, name: "",colorA:"#F00",colorB:"#0F0" }});
	  $('#inputTeamName').focus();
	}

	onNewPlayer(){
		this.setState({currentPlayer : {id : -1, lastName: "", firstName:"", numOrPos:"", playerId:"",role:"player"}});
		$('#inputPlayerFirstName').focus();
	}

	handleColorChangeCompleteA(c) {
		 var t = this.state.currentTeam;
		 if(t!==undefined) {
			 t.colorA = c.hex;
		 }
     this.setState({ currentTeam: t,displayColorpickerA:!this.state.displayColorpickerA,teamUnsave:true});
   };
	 handleColorChangeCompleteB(c) {
			var t = this.state.currentTeam;
			if(t!==undefined) {
				t.colorB = c.hex;
			}
			 this.setState({ currentTeam: t,displayColorpickerB:!this.state.displayColorpickerB,teamUnsave:true});
		 };

	 toogleColorPickerA(){
		 this.setState({displayColorpickerA:!this.state.displayColorpickerA});
	 }

	toogleColorPickerB(){
	 	 this.setState({displayColorpickerB:!this.state.displayColorpickerB});
	}

	render(){
		const {teamsIsLoaded,teams,teamUnsave,currentTeam,currentPlayer,playerUnsave,playersIsLoaded,players} = this.state;
		var isUnsave = function (unsave ,prefix) {
				if(unsave){
					return prefix + "success";
				} else {
					return prefix + "primary disabled";
				}
 		}

		var isUpdate = function (current, prefix) {
				if(current.id>0){
					return prefix + "danger";
				} else {
					return prefix + "danger disabled";
				}
 		}
		console.log("render");
		return (
				<div>
						<div className="row">
								<div className="col-12 col-lg-3 col-xl-3">

								 		<div className="row pt-2">
											 	<div className="col-8"><h3>{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_yourteams_headline')}</h3></div>
										 		<div className="col-4 text-right align-bottom"><button type="button" onClick={this.onNewTeam.bind(this)} className="btn btn-light btn-sm"><span className="glyphicon glyphicon-plus"/></button></div>
										 </div>

										 <div className="row">
										 		<div className="col">
													 <div className="list-group">
															{teamsIsLoaded ? teams.Teams.Team.map((t) =>
																<button key={t.id} onClick={this.onSelectTeam.bind(this,t)} className={t.id === currentTeam.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
																	 <div className="d-flex w-100 justify-content-between">
																		 <small>{t.name}</small>
																		 <img style={{maxWidth : '100px',maxHeight : '25px'}} src={t.logo!==undefined&&t.logo!==""?_GPY.resource("upload/" + t.logo):_GPY.resource("images/guppyi_logo.png")} className="img-fluid" alt="TeamLogo"/>
																	 </div>
																</button>
															) :  <WaitCube/>  }
													 </div>
										 		 </div>
										 </div>


								</div>
								<div className="col-12 col-lg-9 col-xl-9 pt-2">


										<h3>{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_team_headline')}</h3>
										<div className="card bg-light border-success ">
												<div className="card-header">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_team_box_headline')}
													<I18nString callBack={() => this.forceUpdate() } prefix={"gametype_SoccerFootball_teamsettings_team"}/>
												</div>

												<div className="row p-3">
														<div className="col-12">
																<div className="form-group">
																		<label htmlFor="inputTeamName">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_team_box_form_input_name_title')}</label>
																		<input name="teamName" onChange={this.onChange.bind(this,currentTeam,"name","teamUnsave",this.validateTeamName.bind(this))} value={currentTeam.name} type="text" id="inputTeamName" className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_teamsettings_team_box_form_input_name_placeholder')}/>
																</div>
														</div>
												</div>
												<div className="row p-3">
														<div className="col-12 col-md-4">
																	<h5>{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_team_box_teamlogo_headline')}</h5>
																 <img style={{maxWidth : '100px', maxHeight: '100px'}} src={this.state.currentTeam.logo!==undefined&&this.state.currentTeam.logo!==""?_GPY.resource("upload/" + this.state.currentTeam.logo):_GPY.resource("images/default_team_logo.png")} className="img-fluid rounded" alt="Logo"/>
														</div>
														<div className="col-3 col-md-2">
																<h5>{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_team_box_colorA_headline')}</h5>
																<div style={{position: 'absolute',zIndex:5}}>
																<button style={{backgroundColor:this.state.currentTeam.colorA}} type="button" className="btn btn-secondary" onClick={this.toogleColorPickerA.bind(this)}><span className="glyphicon glyphicon-edit"/></button>
																{this.state.displayColorpickerA?<SwatchesPicker   color={ this.state.currentTeam.colorA } onChangeComplete={ this.handleColorChangeCompleteA.bind(this) } />
																:""}
																</div>
														</div>
														<div className="col-3 col-md-2">
																<h5>{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_team_box_colorB_headline')}</h5>
																<div style={{position: 'absolute',zIndex:5}}>
																<button style={{backgroundColor:this.state.currentTeam.colorB}} type="button" className="btn btn-secondary" onClick={this.toogleColorPickerB.bind(this)}><span className="glyphicon glyphicon-edit"/></button>
																{this.state.displayColorpickerB?<SwatchesPicker color={ this.state.currentTeam.colorB } onChangeComplete={ this.handleColorChangeCompleteB.bind(this) } />
																:""}
																</div>
														</div>

														<div className="col-6 col-md-4 text-right">
																<h5>{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_team_box_guppyiid_headline')}</h5>
																<strong className="font-monospace">{this.state.currentTeam.teamId}</strong>
														</div>
												</div>

												<div className="row justify-content-end p-1">
														<div className="col-9 col-md-10 col-lg-10">
																<GpyFileUpload fileTypes="jpg,png" className="btn btn-secondary mr-2" callBack={this.onTeamFileUpload.bind(this)}/>
																{this.state.currentTeam.id>0?
																			<button type="button" className="btn btn-success" onClick={()=>{__GPYPostDownload("getIdCard",{guppyiId:this.state.currentTeam.teamId,fileName:"GuppyiIDCard.pdf"});}}><span className="glyphicon glyphicon-download"/> guppyi IDCard</button>
																:""}
														</div>
														<div className="col-3 col-md-2 col-lg-2 text-right">
																<button type="button" className={isUnsave(teamUnsave,"btn btn-")} onClick={this.createOrUpdateTeam.bind(this)}><span className={currentTeam.id>0?"glyphicon glyphicon-ok":"glyphicon glyphicon-plus"}/></button>
																<button type="button" className={isUpdate(currentTeam,"ml-2 btn btn-")} onClick={this.deleteTeam.bind(this)}><span className="glyphicon glyphicon-remove"/></button>
														</div>
												</div>
										</div>


								 </div>
						</div>


{currentTeam.id > 0 ?

						<div className="row mt-5">
						    <div className="col-12 col-lg-3 col-xl-3">


						          <div className="row">
							           <div className="col-8"><h5> {_GPY.i18n.get('gametype_SoccerFootball_teamsettings_playerlist_headline')} <small className="text-muted">{currentTeam.name}</small></h5></div>
							           <div className="col-4 text-right align-bottom">
							             <button type="button" onClick={this.onNewPlayer.bind(this)} className="btn btn-light btn-sm"><span className="glyphicon glyphicon-plus"/></button>
							           </div>
						          </div>


						          <div className="row pt-2">
												 <div className="col">
								             <div className="list-group">

										           { playersIsLoaded ? players.Players.Player.map((p) =>
										             <button key={p.id} onClick={this.onSelectPlayer.bind(this,p)} className={p.id === currentPlayer.id?"list-group-item list-group-item-action list-group-item-primary flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
										                <div className="d-flex w-100 justify-content-between">
										                 <small>{p.firstName} {p.lastName} {p.numOrPos!==undefined && p.numOrPos!==''?" "+p.numOrPos:""} {p.role!==undefined&&p.role!==''?" ("+_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_role_'+p.role)+")":""}</small>
										                 <img style={{maxWidth : '100px', maxHeight : '25px'}} src={p.profileImage!==undefined&&p.profileImage!==""?_GPY.resource("upload/" + p.profileImage):_GPY.resource("images/default_avatar.jpg")} className="img-fluid" alt="Player Avatar"/>
										                </div>
										             </button>
										           ) :  <div/>  }

								  					</div>
												</div>
										</div>


							 </div>
						 	 <div className="col-12 col-lg-9 col-xl-9">


							 					 <h5>{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_headline')}</h5>
				                 <div className="card bg-light border-primary my-3">
				                   <div className="card-header">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_headline')}
													     <I18nString callBack={() => this.forceUpdate() } prefix={"gametype_SoccerFootball_teamsettings_player"}/>
													 </div>

													   <div className="row p-2">

															 <div className="col-12 col-md-2 mb-1 text-center">
				                          <img style={{maxWidth : '100px', maxHeight: '100px'}} src={this.state.currentPlayer.profileImage!==undefined&&this.state.currentPlayer.profileImage!==""?_GPY.resource("upload/" + this.state.currentPlayer.profileImage):_GPY.resource("images/default_avatar.jpg")} className="img-fluid" alt="Player Avatar"/>
				                       </div>

															 <div className="col-12 col-md-10">
															 <div className="row">

					                       <div className="col-12 col-md-3">
					                         <div className="form-group">
																	 	 <label htmlFor="inputTeamName">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_firstname_title')}</label>
					                           <input name="firstName" type="text" id="inputPlayerFirstName" onChange={this.onChange.bind(this,currentPlayer,"firstName","playerUnsave",this.validatePlayerLastName.bind(this))} value={currentPlayer.firstName} className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_firstname_placeholder')}/>
					                         </div>
					                       </div>

					                       <div className="col-12 col-md-3">
					                         <div className="form-group">
																	   <label htmlFor="inputTeamName">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_lastname_title')}</label>
					                           <input name="lastName" type="text"  onChange={this.onChange.bind(this,currentPlayer,"lastName","playerUnsave",this.validatePlayerLastName.bind(this))} value={currentPlayer.lastName} className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_lastname_placeholder')}/>
					                         </div>
					                       </div>

					                       <div className="col-12 col-md-3">
					                         <div className="form-group">
																	   <label htmlFor="inputTeamName">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_numorpos_title')}</label>
					                           <input name="numOrPos" type="text"  onChange={this.onChange.bind(this,currentPlayer,"numOrPos","playerUnsave",this.validatePlayerLastName.bind(this))} value={currentPlayer.numOrPos} className="form-control" placeholder={_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_numorpos_placeholder')}/>
					                         </div>
					                       </div>

					                       <div className="col-12 col-md-3 text-center">
					                           <span>{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_guppyiid_headline')}</span><br/>
					                           <strong className="font-monospace">{this.state.currentPlayer.playerId}</strong>
					                       </div>

																 <div className="col-12 col-md-12">
																	 <div className="form-group">
																		<label htmlFor="inputInfo">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_role_title')}</label>
																		<select value={this.state.currentPlayer.role} onChange={this.onChange.bind(this,currentPlayer,"role","playerUnsave",this.validateAny.bind(this))} class="form-control" id="exampleFormControlSelect2">
																      <option value="player">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_role_player')}</option>
																      <option value="coach">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_role_coach')}</option>
																    </select>
																	 </div>
																 </div>

															   <div className="col-12 col-md-12">
															     <div className="form-group">
															 	    <label htmlFor="inputInfo">{_GPY.i18n.get('gametype_SoccerFootball_teamsettings_player_box_form_input_info_title')}</label>
															 	    <textarea value={this.state.currentPlayer.info} ref="summaryContent" rows="5" name="info" onChange={this.onChange.bind(this,currentPlayer,"info","playerUnsave",this.validateAny.bind(this))} className="form-control"></textarea>
															     </div>
																 </div>

															</div>
														</div>
													</div>


				                   <div className="row justify-content-end  p-1">
				                       <div className="col-9 col-md-10 col-lg-10">
				                           <GpyFileUpload aspectRatio="1" fileTypes="jpg,png" className="btn btn-secondary mr-2"  callBack={this.onPlayerFileUpload.bind(this)} />
																	 {this.state.currentPlayer.id>0?
																				 <button type="button" className="btn btn-success" onClick={()=>{__GPYPostDownload("getIdCard",{guppyiId:this.state.currentPlayer.playerId,fileName:"GuppyiIDCard.pdf"});}}><span className="glyphicon glyphicon-download"/> guppyi IDCard</button>
																	 :""}
				                       </div>
				                       <div className="col-3 col-md-2 col-lg-2 text-right">
				                            <button className={isUnsave(playerUnsave,"btn btn-")} onClick={this.createOrUpdatePlayer.bind(this)}><span className={currentPlayer.id>0?"glyphicon glyphicon-ok":"glyphicon glyphicon-plus"}/></button>
																		<button type="button" className={isUpdate(currentPlayer,"ml-2 btn btn-")} onClick={this.deletePlayer.bind(this)}><span className="glyphicon glyphicon-remove"/></button>
				                       </div>
				                   </div>

				                 </div>


						   </div>

					</div>

:<span></span>}

		 </div>

		)
	}

}
export default TeamSettings;
